import { ApiResponseCategory } from 'models/ApiResponseCategory';

export const getActiveCategoryByCategoryPath = (
  category: string,
  categoryData: ApiResponseCategory[]
) => {
  const wantedCategory =
    categoryData &&
    categoryData.filter((singleData) => singleData.urlPath === `${category}`);
  if (wantedCategory && wantedCategory.length !== 0) {
    return wantedCategory[0];
  }

  return null;
};
